<div class="container" style="padding-top: 25px">
    <div class="row">
        <div class="col-sm">
            <h3>{{ game_name }}</h3>
        </div>
        <div class="col-sm">
            <div style="padding-left: 10px;">
                <button type="button" class="btn btn-secondary btn-sm" v-for="point in points" :key="point.value"
                    @click="pointClick(point.value)"> {{ point.display }} </button>
            </div>
        </div>
        <div class="col-sm">
            <p>Punkty: {{ curernt_point }}</p>
        </div>
    </div>
    <table class="table table-striped table-sm">
        <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col">Gracz</th>
                <th scope="col">Punkty</th>
                <th scope="col">Ostatnie punkty</th>
                <th scope="col">Dodaj punkty</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in items" :key="item.user_id">
                <td>{{ item.user_id }}</td>
                <td>{{ item.user_name }}</td>
                <td>{{ item.point }}</td>
                <td>{{ item.last_point }}</td>
                <td><button type="button" @click="userClick(item.user_id)"
                        class="btn btn-outline-primary btn-sm">+</button></td>
            </tr>
        </tbody>
    </table>
</div>